import { render, staticRenderFns } from "./ActionBarCom.vue?vue&type=template&id=5b70edb7&"
import script from "./ActionBarCom.vue?vue&type=script&lang=ts&"
export * from "./ActionBarCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports